/**
 * Имена каналов стола. Отдельный файл без zustand: реле на forq.ru
 * импортирует только их. Тянуть `desk.ts` — значит вставить React в
 * страницу, а у React в CJS стоит `process.env.NODE_ENV`. В MV3
 * `process` нет, и расширение падает ещё до ping.
 */

export const DESK_CH = 'forq:desk';
export const DESK_OK = 'forq:desk:ok';
